<header class="flex items-start justify-between gap-md">
  <div class="min-w-0">
    <h3
      class="text-base font-semibold text-neutral-900"
      data-insight-card-title>
      {{ cardTitle() }}
    </h3>
    @if (subtitle()) {
      <p class="text-xs text-neutral-500 mt-x-sm" data-insight-card-subtitle>
        {{ subtitle() }}
      </p>
    }
  </div>

  <div class="shrink-0 empty:hidden">
    <ng-content select="[insightCardAction]" />
  </div>
</header>

<ng-content />
